/**
 * @generated SignedSource<<f64281e4b9ee4e9a37efc8ccf1d92d54>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppSettingsFormUpdateMutation$variables = {
  description?: string | null | undefined;
  id: string;
  name?: string | null | undefined;
  slug?: string | null | undefined;
};
export type AppSettingsFormUpdateMutation$data = {
  readonly updateApp: {
    readonly description: string;
    readonly id: string;
    readonly name: string;
    readonly slug: string;
  };
};
export type AppSettingsFormUpdateMutation = {
  response: AppSettingsFormUpdateMutation$data;
  variables: AppSettingsFormUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "App",
    "kind": "LinkedField",
    "name": "updateApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppSettingsFormUpdateMutation",
    "selections": (v4/*:: as any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AppSettingsFormUpdateMutation",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "8a0788c675d6cb61c7c1b9791baa53ef",
    "id": null,
    "metadata": {},
    "name": "AppSettingsFormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AppSettingsFormUpdateMutation(\n  $id: ID!\n  $name: String\n  $description: String\n  $slug: String\n) {\n  updateApp(id: $id, name: $name, description: $description, slug: $slug) {\n    id\n    name\n    description\n    slug\n  }\n}\n"
  }
};
})();

(node as any).hash = "71c9c9b7a1e9f3ed7644ece531376267";

export default node;
